<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="action_type" @change="getLogList(true)" :disabled="loading" size="sm")
            option(value="") {{ $t('ui.all') }}
            option(value="ADJUST") {{ $t('ui.adjust') }}
            option(value="GENERATE VOUCHER") {{ $t("ui.generate_voucher") }}
            option(value="REDEEM CASH") {{ $t("ui.redeem_cash") }}
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.text-right(width="10%")
                  span(:title="$t('ui.balance_before')") {{ $t('ui.balance_before') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.balance_after')") {{ $t('ui.balance_after') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.action_status')") {{ $t('ui.action_status') }}
                th(width="18%")
                  span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                th(width="12%")
                  span(:title="$t('ui.action_by_operator')") {{ $t('ui.action_by_operator') }}
                th.text-right(width="15%" @click="sortOrder('action_date')")
                  span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                  .float-right
                    i(:class="changeSortKey('action_date')")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(:colspan="7").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                td.text-center
                  span(:title="item.action_type") {{ item.action_type }}
                td
                  span(:title="item.remark") {{ item.remark }}
                td
                  span(:title="item.action_by_parent") {{ item.action_by_parent }}
                td.text-right
                  span.d-block(:title="item.action_by") {{ item.action_by }}
                  span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    account_id: "",
    action_type: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    logList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "action_date",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      action_type: '',
    };
    this.$store.dispatch("user/setMemberWalletVoucherLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.memberLog.action_type != null && this.$store.getters.memberLog.action_type != '') {
        this.action_type = this.$store.getters.memberLog.action_type;
      }

      this.getLogList(true);
    },
    setMemberWalletVoucherLogParam: function() {
      var json = {
        action_type: this.action_type,
      };
      this.$store.dispatch("user/setMemberWalletVoucherLogParam", json);
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getLogList: function(isSearch) {
      this.setMemberWalletVoucherLogParam();
      let url = config.memberWalletVoucherLogUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.memberID,
        action_type: this.action_type,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.logList = response.data.dt;
                this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'memberwalletvoucherlog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>